<template>
  <a-card :bordered="false">
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item :label="$t('OLD_PASSWORD')||'原密码'">
        <a-input-password
          size="large"
          v-model="form.data.oldPassword"
          :disabled="form.disabled"
          show-password>
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item :label="$t('NEW_PASSWORD')||'原密码'">
        <a-input-password
          size="large"
          v-model="form.data.newPassword"
          :disabled="form.disabled"
          show-password>
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          @click="confirmPassword"
          type="primary">
          {{ $t('UPDATE') || '更新' }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import {
  _updateUserPassword,
} from '@/api/sys/sysUserApi';

async function confirmPassword() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      this.form.disabled = true;
      const result = await _updateUserPassword({
        newPassword: this.form.data.newPassword,
        oldPassword: this.form.data.oldPassword,
      });
      if (result && result) {
        this.form.disabled = false;
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        return;
      }
      this.$message.error('原密码输入错误');
      this.form.disabled = false;
    }
  });
}


export default {
  name: 'Setting',
  methods: {
    confirmPassword,
  },
  mounted() {
  },
  data() {
    return {
      autoLogin: false,
      form: {
        disabled: false,
        data: {
          oldPassword: null,
          newPassword: null,
        },
        rule: {

          oldPassword: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur',

          }],
          newPassword: [
            {
              required: true,
              message: 'Please input password',
              trigger: 'blur',
            },
            {
              min: 8,
              message: 'Length should be 3 to 5',
              trigger: 'blur',
            },
          ],
        },
      },
    };
  },
};
</script>

<style>
.login-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f0f2f5;
  overflow: hidden;

}

.login-page .a-form-model-item__label {
  color: #ffffff;
}


.login-form-wrap {
  border-radius: 5px;
  /*background: #ffffff24;*/
  padding: 40px;
}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  /*background-image: linear-gradient(122deg, #000000 0%, #52383d 27%, #ffffff 100%);*/

}
</style>
